export const ProcessState = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  WITHDRAWN: 'WITHDRAWN',
  ANNULLED: 'ANNULLED',

  values: () => {
    return ['DRAFT', 'SUBMITTED', 'APPROVED', 'REJECTED', 'WITHDRAWN', 'ANNULLED'];
  },

  finalStates: () => {
    return ['APPROVED', 'REJECTED'];
  },

  valuesExcludingRejectAndWithdrawn: () => {
    return ['DRAFT', 'SUBMITTED', 'APPROVED'];
  },
};
